module.exports = __webpack_public_path__ + "static/media/icon_checkbox_active.621fee53.svg";